import { useTheme } from "@hooks";
import { Oval } from "react-loader-spinner";
import { useStyles } from "./styles";

export const Loader = () => {
  const styles = useStyles();
  const { theme } = useTheme();

  return (
    <div style={styles.container}>
      <Oval
        visible
        height={50}
        width={50}
        color={theme.loader.default}
        secondaryColor={theme.loader.secondary}
        strokeWidth={4}
        strokeWidthSecondary={4}
        ariaLabel="loading"
      />
    </div>
  );
};
